// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import TysiaProgress from './view'

export default function TysiaProgressFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/TysiaProgress">
      <TysiaProgress {...props}>
        {children}
      </TysiaProgress>
    </Flow>
  )
}
